import { baseReducer as BaseReducer } from '../../store/core/base-reducer';
import { calculatePagingStats, FIRST_PAGE, PAGE_SIZE_100 } from '../../services/pagination-service';

import * as Actions from './paging.actions';

const initialState = {};

const actionHandlerMap = {
  [Actions.SET_INITIAL_VIEW_PAGE_STATS]: (state, { viewName, page, pageSize, totalRecords }) => {
    const calculatedPagingStats = calculatePagingStats(page || FIRST_PAGE, pageSize, totalRecords);
    const viewsStats = {
      [viewName]: calculatedPagingStats,
    };
    return {
      ...state,
      ...viewsStats,
    };
  },
  [Actions.SET_TOTAL_RECORDS]: (state, { viewName, totalRecords }) => {
    const { page, pageSize } = state[viewName];
    const calculatedPagingStats = calculatePagingStats(page || FIRST_PAGE, pageSize, totalRecords);
    const viewsStats = {
      [viewName]: calculatedPagingStats,
    };
    return {
      ...state,
      ...viewsStats,
    };
  },
  [Actions.SET_VIEW_PAGE_AND_PAGE_SIZE]: (state, { viewName, page, pageSize }) => {
    const pagingStats = state[viewName] || calculatePagingStats(FIRST_PAGE, pageSize || PAGE_SIZE_100, 0);
    pagingStats.page = page;
    pagingStats.pageSize = pageSize;
    const viewsStats = {
      [viewName]: pagingStats,
    };
    return {
      ...state,
      ...viewsStats,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './paging.reducer.metadata';
